import axios from "axios";
import { toast } from "sonner";
import { supabaseAccessToken } from "@/lib/supabase";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Resolve backend-served images. Stored file URLs are relative (`/api/files/...`)
// so they render in any environment; prepend the backend origin at render time.
export function resolveImg(url) {
  if (!url || typeof url !== "string") return url || "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

// Only allow http(s) links as hrefs; blocks javascript:/data: schemes from user-entered URLs.
export function safeHref(url) {
  if (!url || typeof url !== "string") return "";
  try {
    const u = new URL(url, window.location.origin);
    return u.protocol === "http:" || u.protocol === "https:" ? url : "";
  } catch {
    return "";
  }
}

api.interceptors.request.use((config) => {
  const token = supabaseAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Friendly notice when a public endpoint is rate-limited.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 429) {
      toast.error("You're going a little fast — please wait a moment and try again.");
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
